import axios from 'axios';
import router from '@/router';
import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_S1MUS_API_URL
});

axiosInstance.interceptors.request.use((config) => {
    config.headers.Authorization = getUserToken();
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            router.push({name:'login'});
        }
        return Promise.reject(error);
    }
);

axiosInstance.buildBuilding = async function (planetId, buildingTypeId) {
    return this.post('/api/building/build',
        {
            planetId: planetId,
            buildingTypeId: buildingTypeId
        }
    );
};

axiosInstance.getPlanetBuildings = async function (planetId) {
    return this.get(`/api/building/data/user/planet/${planetId}/view`);
};

axiosInstance.getPlanetDefenses = async function (planetId) {
    return this.get(`/api/defense/data/user/planet/${planetId}/view`);
};

axiosInstance.getPlanetResources = async function (planetId) {
    return this.get(`/api/user/planet/${planetId}/resources`);
};

axiosInstance.getPlanetShips = async function (planetId) {
    return this.get(`/api/ship/data/user/planet/${planetId}/view`);
};

axiosInstance.getUserTechnology = async function (planetId) {
    return this.get(`/api/technology/data/user/planet/${planetId}/view`);
};

axiosInstance.buildDefense = async function (planetId, defenseTypeId, amount) {
    return this.post('/api/defense/build',
        {
            planetId: planetId,
            defenseTypeId: defenseTypeId,
            amount: amount
        }
    );
};

axiosInstance.buildShip = async function (planetId, shipTypeId, amount) {
    return this.post('/api/ship/build',
        {
            planetId: planetId,
            shipTypeId: shipTypeId,
            amount: amount
        }
    );
};

axiosInstance.login = async function (username, password) {
    return this.post('/api/token/app', {
        username: username,
        password: password
    });
}

axiosInstance.researchTechnology = async function (planetId, technologyTypeId) {
    return this.post('/api/technology/research',
        {
            planetId: planetId,
            technologyTypeId: technologyTypeId
        }
    );
};

axiosInstance.refreshToken = async function () {
    return this.get('/api/token/refresh');
}

function getUserToken() {
    const userLoginDataStorageInstance = userLoginDataStorage();
    return userLoginDataStorageInstance.getUserToken();
}

export default {
    install(app) {
        app.config.globalProperties.$axios = axiosInstance
    }
};